import { useState } from "react";

import { FLOW_AREA } from "../../constants/flow";
import DocsTemplatesServices from "../../services/DocsTemplatesServices";
import { downloadBlob } from "../../utils/utility";
import { LeftInfoModalProps } from "../../components/left-info-modal/left-info-modal-layout";
import { UseExportInsuredsProps, UseExportInsuredsReturn } from "./useExportInsureds-types";

export const useExportInsureds = ({ getCsvData, flow, fileName }: UseExportInsuredsProps): UseExportInsuredsReturn => {
  const cleanErrorModal: Partial<LeftInfoModalProps> = {
    mainTitle: "",
    mainText: "",
    active: false,
  };

  const [optionsModalActive, setOptionsModalActive] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<Partial<LeftInfoModalProps>>(cleanErrorModal);
  const [loading, setLoading] = useState<boolean>(false);

  const openOptionsModal = () => setOptionsModalActive(true);
  const closeOptionsModal = () => setOptionsModalActive(false);
  const resetErrorModal = () => setErrorModal(cleanErrorModal);

  const exportTemplate = async () => {
    closeOptionsModal();
    setLoading(true);
    try {
      const response = await DocsTemplatesServices.getImportInsuredTemplate({
        setLoading: () => {},
        loader: false,
        isSimulation: flow === FLOW_AREA.SIMULACION,
      });

      if (response.ok) {
        const data = Uint8Array.from(response.data.data.data as number[]);
        const blob = new Blob([data], { type: response.data.contentType });
        downloadBlob(blob, response.data.name);
      } else {
        setErrorModal({
          active: true,
          mainTitle: "Error en la descarga de la plantilla",
          mainText: response.message,
        });
      }
    } catch {
      setErrorModal({
        active: true,
        mainTitle: "Error en la exportación de la plantilla",
        mainText:
          "Se ha producido un error en la exportación de la plantilla, por favor inténtelo de nuevo más tarde.",
      });
    } finally {
      setLoading(false);
    }
  };

  const exportData = () => {
    closeOptionsModal();
    setLoading(true);
    try {
      const csvContent = getCsvData();
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      downloadBlob(blob, fileName);
    } catch {
      setErrorModal({
        active: true,
        mainTitle: "Error en el proceso de exportación de los datos",
        mainText:
          "Se ha producido un error en la exportación del archivo, por favor inténtelo de nuevo más tarde.",
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    optionsModalActive,
    errorModal,
    openOptionsModal,
    closeOptionsModal,
    exportTemplate,
    exportData,
    resetErrorModal,
  };
};
